var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConversationWhiteIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Conversations_gray",
    transform: "translate(-10039 760)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160891",
    "data-name": "Group 160891",
    transform: "translate(10039 -760)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160890",
    "data-name": "Group 160890"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140092",
    "data-name": "Rectangle 140092",
    width: 12,
    height: 12,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "My_Team_gray",
    "data-name": "My Team_gray",
    transform: "translate(2971.05 -332.328)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1106",
    "data-name": "Rectangle 1106",
    width: 3.362,
    height: 1,
    rx: 0.5,
    transform: "translate(7071.513 -422.203)",
    fill: "#71839b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2334",
    "data-name": "Path 2334",
    d: "M10.848,8.284a.967.967,0,0,1-.979.956H4.012L2.06,11.152V3.506a.967.967,0,0,1,.979-.956H9.874a.967.967,0,0,1,.978.956s-.008,2.093,0,2.794S10.848,8.284,10.848,8.284Z",
    transform: "translate(7067.489 -428.384)",
    fill: "none",
    stroke: "#71839b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2335",
    "data-name": "Path 2335",
    d: "M0,0H9.822V9.822H0Z",
    transform: "translate(7069.243 -426.526)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1952",
    "data-name": "Rectangle 1952",
    width: 4.687,
    height: 1,
    rx: 0.5,
    transform: "translate(7071.513 -424.016)",
    fill: "#71839b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversationWhiteIcon);
export default __webpack_public_path__ + "static/media/conversation-white-icon.fbc680ff2a5f9ab9e704765fb08d7238.svg";
export { ForwardRef as ReactComponent };